import user from './user';
import h from './common';

const subscription = {
    /**
     * Function to check if the given packages belong to the user's active packages.
     * @param packages
     * @returns {boolean}
     */
    checkItemBelongsToActivePackages: (packages: string[]): boolean => {
        if (!packages || !packages.length) {
            return true;
        }
        const userActiveSubscriptionGuids = user.getUserActiveSubscribedGuids();
        if (!userActiveSubscriptionGuids) return false;
        return userActiveSubscriptionGuids.some((item) => packages.includes(item));
    },
    /**
     * Function to check if the given packages belong to the user's addon packages.
     * @param packages
     * @returns {boolean}
     */
    checkItemBelongsToAddonsPackages: (packages: string[]): boolean => {
        if (!packages) {
            return false;
        }
        const extraSubscriptionsGuids = h.getExtraSubscriptionsForUserSegment();
        if (!extraSubscriptionsGuids) return false;
        return extraSubscriptionsGuids.some((item) => packages.includes(item));
    },
    /**
     * Function to check if the given subscription GUID belongs to the user's active packages.
     * @param subscriptionGuid
     * @returns {boolean}
     */
    checkSubscriptionGuidBelongsToUserActivePackages: (subscriptionGuid: string): boolean => {
        if (!subscriptionGuid) {
            return false;
        }
        const userActiveSubscriptionGuids = user.getUserActiveSubscribedGuids();
        if (!userActiveSubscriptionGuids) return false;
        return userActiveSubscriptionGuids.some((item) => item === subscriptionGuid);
    },
};

export default subscription;
